import React from 'react'
import store from '../../state/appStore'

const withReducer = (key, reducer) => WrappedComponent => {
  store.injectReducer(key, reducer)
  return props => <WrappedComponent {...props} />
}

export default withReducer



// WEBPACK FOOTER //
// ./src/legacy/store/withReducer.jsx